import React from 'react';
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import useAuthentication from '../../hooks/useAuthentication.js';

const MainHeader = () => {
    const { logout } = useAuthentication();

    const token = sessionStorage.getItem('accessToken');
    const decoded = jwtDecode(token);

    const authorizedIndividuals = [
        'jim@practicebooster.com',
        'innovation.testing@practicebooster.com'
    ];

    return (
        <div className="main-header">
            <Link
                to="/"
                style={{
                    marginLeft: '1em',
                    color: 'black',
                    textDecoration: 'none'
                }}>
                <p>Get My Signature</p>
            </Link>
            <Link
                to="updateSignature"
                style={{
                    marginRight: '1em',
                    color: 'black',
                    textDecoration: 'none'
                }}>
                <p>Activate/Update My Signature</p>
            </Link>
            {authorizedIndividuals.includes(decoded.email) && (
                <Link
                    to="/upload"
                    style={{
                        marginRight: '1em',
                        color: 'black',
                        textDecoration: 'none'
                    }}>
                    <p>Upload New Signature Image</p>
                </Link>
            )}
            <div
                onClick={async () => logout()}
                style={{
                    marginRight: '1em',
                    color: 'black',
                    textDecoration: 'none',
                    cursor: 'pointer'
                }}>
                <p>Logout</p>
            </div>
        </div>
    );
};

export default MainHeader;
